import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionUser } from '../app.models';
import { HostService } from './host.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionUserService {

  constructor(private getHost: HostService,
              private http: HttpClient) { }


  create(permission_user: PermissionUser) {

    return this.http.post(this.getHost.gethttps() + "permissionUser", permission_user);
    
  }

  index(idUser: number) {

    return this.http.get(this.getHost.gethttps() + "permissionUser/"+idUser);
    
  }
}
